<template>
    <v-dialog v-model="isActive" max-width="690px" scrollable :persistent="bloqueoCerrar"
        @keydown.esc="confirmAndClose(true)" transition="dialog-transition" :fullscreen="fullscreen">
        <v-card class="rounded-0">
            <v-card class="rounded-0 elevation-0">
                <v-app-bar flat class="rounded-0" color="white" style="min-height: auto;">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" icon @click.outside="confirmAndClose(true)">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Cerrar</span>
                    </v-tooltip>
                    <v-toolbar-title class="text-body-1 text-uppercase font-weight-regular primary--text"
                        style="white-space: normal; word-break: break-word;">
                        {{ titulo }}
                    </v-toolbar-title>
                </v-app-bar>
            </v-card>
            <v-card-text v-html="formattedText" class="black--text py-0">
            </v-card-text>
            <v-card-actions class="d-flex justify-center align-center">
                <v-btn class="py-5 px-9" elevation="0" color="primary" @click="confirmAndClose(true)">
                    cerrar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        titulo: {
            type: String,
            required: false,
            default: 'Términos y condiciones generales para el uso del portal de afiliados'
        },
        bloqueoCerrar: {
            type: Boolean,
            required: false,
            default: true
        },
        fullscreen: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        formattedText() {
            return this.text.replace(/([a-l]\))/g, '<div style="margin: 15px 0;"><strong>$1</strong>');
        }
    },
    data() {
        return {
            isActive: false,
            callback: null,
            text: `a) El sistema electrónico contemplado en la presente resolución deberá guardar adecuada consistencia y se ajustará en un todo a los principios generales previstos por el Plan Estratégico General de Modernización aprobado por la Resolución A-1780/2024. El ingreso y la utilización de este portal se rigen por las disposiciones de la legislación argentina, en todo cuanto no se encuentre previsto en los presentes términos y condiciones.
                    b) El “PORTAL DEL AFILIADO” es una herramienta de gestión que no sustituye los procedimientos administrativos previstos en la Ley 12.163(T.O.Ley 14.054) y en los diversos Reglamentos de la Institución, y todas las etapas desarrolladas a través del mismo respetaran las pautas y principios allí establecidos, permitiendo gestionar de manera virtual y progresiva los diferentes trámites de la entidad hasta alcanzar la completa adecuación de la reglamentación aplicable en cada caso a las nuevas tecnologías de la información y las comunicaciones (TIC‘s).
                c) La información incorporada o disponible en el portal se encontrará protegida por las previsiones del
                ordenamiento jurídico en materia de propiedad intelectual.
                d) La Caja de Seguridad Social para los Psicólogos de la Provincia de Buenos Aires se reserva el derecho
        a
        limitar, restringir o eliminar el acceso a sus sistemas y servicios cuando surjan dificultades técnicas
                por hechos o circunstancias ajenas al Organismo que, a su criterio, disminuyan o anulen los niveles de
                seguridad adoptados para el adecuado funcionamiento del portal.
                e) El usuario se compromete a utilizar el portal, sus servicios y sus contenidos en forma lícita y de
                acuerdo con las políticas, términos y condiciones de uso, sin contravenir la legislación aplicable, la
                buena fe y el orden público.En consecuencia, queda prohibido todo uso con fines ilícitos o que
        perjudiquen, impidan, puedan dañar o sobrecargar de cualquier forma la utilización y normal
                funcionamiento del portal o que, en forma directa o indirecta, atente contra sí mismo o contra cualquier
                derecho de un tercero.
                f) Los usuarios del “PORTAL DEL AFILIADO” no podrán ceder, transferir o comunicar las modalidades de
        acceso, siendo responsables por los actos, documentos y demás antecedentes que ingresen utilizando tales
        variantes.
                g) La Caja de Seguridad Social para los Psicólogos de la Provincia de Buenos Aires no se responsabiliza
        por: 1) Las interrupciones del servicio o inconvenientes originados en causas que impidan el acceso que
                no le sean imputables. 2) Por la veracidad e integridad de la información y del contenido de los
                documentos utilizados, los cuales son de exclusiva responsabilidad de los usuarios que los envían. 3)
            Los daños generados por virus, programas maliciosos o lesivos en los contenidos o cualquier otro
                software que pueda llegar a infectar o afectar de cualquier modo el o los sistemas informáticos
                utilizados por el usuario.
                h) Cuando se solicite por parte de terceros accesos a información que pudiese afectar derechos de los
        usuarios, tales como los relacionados con su vida privada o derechos de carácter económico o comercial,
            se procederá de acuerdo con lo previsto por el ordenamiento vigente y, en especial, por la Ley de
                Protección de Datos Personales Nº 25.326 y por sus normas modificatorias y complementarias.
                i) La Caja de Seguridad Social para los Psicólogos de la Provincia de Buenos Aires se reserva el derecho
        de
                modificar o eliminar el contenido, estructura, diseño, servicios y condiciones de acceso y / o uso del
        portal, en cualquier momento y sin necesidad de previo aviso.
            j) Los usuarios del sistema declararan conocer y aceptar la circunstancia relativa a que el Organismo
        puede
                en cualquier momento modificar en todo o en parte las presentes políticas, términos y condiciones de
        Uso.
            k) La cuenta personal creada por los usuarios, podrá constituirse en su domicilio electrónico donde
        serán
                válidas y eficaces todas aquellas comunicaciones y notificaciones que emanen del sistema.
            l) El ingreso de los usuarios al “PORTAL DEL AFILIADO” implicará la aceptación inmediata y sin reserva
        de
                los presentes términos y condiciones.En consecuencia, aquellos deberán manifestar haberlos leído y
                aceptarlos en su totalidad, plenamente y sin reserva alguna, siendo dicha aceptación indispensable para
                su utilización.Así también se aceptarán las condiciones particulares que en el futuro puedan
        complementarlos, sustituirlos o modificarlos en algún sentido en relación con los servicios y contenidos
                del portal. `,
        }
    },
    methods: {

        confirmAndClose(result) {
            if (this.callback) {
                this.callback(result);
                this.callback = null;
            }
            this.isActive = false;
        },
        abrirDialogo() {
            this.isActive = true;
            return new Promise(resolve => {
                this.callback = resolve;
            })
        },
    }
}

</script>